import { render, staticRenderFns } from "./deviceGateList.vue?vue&type=template&id=0aa88b00&scoped=true"
import script from "./deviceGateList.vue?vue&type=script&lang=ts"
export * from "./deviceGateList.vue?vue&type=script&lang=ts"
import style0 from "./deviceGateList.vue?vue&type=style&index=0&id=0aa88b00&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa88b00",
  null
  
)

export default component.exports